import { useDeleteConfirmationDialog } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { useCancellationPolicyDeleteMutation } from '../queries';
import { WithCancellationPolicyId } from '../types';

interface Params extends WithCancellationPolicyId {
    onSuccess?: () => void;
}
export const useDeleteCancellationPolicyDialog = ({ cancellationPolicyId, onSuccess }: Params) => {
    const deleteMutation = useCancellationPolicyDeleteMutation();
    const deleteAction = async () =>
        deleteMutation.mutateAsync(
            { cancellationPolicyIds: [cancellationPolicyId] },
            {
                onSuccess,
            }
        );
    return useDeleteConfirmationDialog({
        deleteAction,
        renderContent: () => lt('CancellationPolicyDeleteDialogContent'),
        title: lt('CancellationPolicyDeleteDialogTitle'),
    });
};
